import {
  addDoc,
  CACHE_SIZE_UNLIMITED,
  collection,
  deleteDoc,
  doc,
  getCountFromServer,
  getDoc,
  getDocs,
  initializeFirestore,
  limit,
  onSnapshot,
  orderBy,
  persistentLocalCache,
  query,
  runTransaction,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
  where,
  QueryDocumentSnapshot,
  DocumentData,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";

import {
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import { getMessaging, getToken as firebaseGetToken } from "firebase/messaging";
import { USERS_COLLECTION } from "./constants/collections";
import { Messaging } from "@firebase/messaging";

const tizimappFirebaseConfig = {
  apiKey: "AIzaSyC8NBeBZSYNMMwhHpTcrQsL2fahn4EP33E",
  authDomain: "rent-d24be.firebaseapp.com",
  projectId: "rent-d24be",
  storageBucket: "rent-d24be.firebasestorage.app",
  messagingSenderId: "944304923603",
  appId: "1:944304923603:web:3098e33e0e026177be4526",
  measurementId: "G-LCWR64EBHP",
};

console.log("users collection", USERS_COLLECTION);

const app = initializeApp(tizimappFirebaseConfig);

console.log("🔍 Firebase App initialized:", {
  name: app.name,
  options: app.options,
});

const auth = getAuth();

// Initialize Firestore with persistence enabled
const db = initializeFirestore(app, {
  localCache: persistentLocalCache(
    /*settings*/ {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED,
    },
  ),
});

const functions = getFunctions();
const storage = getStorage();

// Guard messaging for environments that don't support the required browser APIs
function isMessagingSupported(): boolean {
  try {
    return (
      typeof window !== "undefined" &&
      typeof navigator !== "undefined" &&
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window
    );
  } catch (err) {
    return false;
  }
}

const messaging = (isMessagingSupported() ? getMessaging() : null) as Messaging;

const getToken = async (...args: any[]) => {
  if (!messaging) {
    console.warn(
      "Firebase Messaging is not supported in this environment (messaging/unsupported-browser). Skipping getToken.",
    );
    return null;
  }
  try {
    return await firebaseGetToken(messaging as any, ...args);
  } catch (err) {
    console.warn("firebaseGetToken failed:", err);
    throw err;
  }
};

const useEmulators = process.env.EXPO_PUBLIC_USE_EMULATORS === "true";

if (window.location.hostname === "localhost" && useEmulators) {
  console.log("Connecting to emulators...");
  // connectFirestoreEmulator(db, "127.0.0.1", 8080);
  // connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

// Enable offline persistence for web
// Note: Firebase v9+ has offline persistence enabled by default
// No additional configuration needed for basic offline functionality

const resetPassword = (email: string) => sendPasswordResetEmail(auth, email);

// Count query function for web
const getCollectionCount = async (
  collectionName: string,
  constraintData: Array<{ field: string; operator: any; value: any }>,
): Promise<number> => {
  const collectionRef = collection(db, collectionName);
  const queryConstraints = constraintData.map(({ field, operator, value }) =>
    where(field, operator, value),
  );
  const q = query(collectionRef, ...queryConstraints);
  const snapshot = await getCountFromServer(q);
  return snapshot.data().count;
};

export {
  auth,
  serverTimestamp,
  doc,
  setDoc,
  collection,
  addDoc,
  db,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  updateDoc,
  getDoc,
  deleteDoc,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  onSnapshot,
  Timestamp,
  functions,
  runTransaction,
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  getToken,
  messaging,
  resetPassword,
  httpsCallable,
  getCollectionCount,
  QueryDocumentSnapshot,
  DocumentData,
};
